/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useLocation } from 'react-router-dom';
import FooterSubM from './footer-subm';
import FooterSubONew from './footer-subonew';
import FooterSubC from './footer-subc';
import FooterSubCareer from './footer-subcareer';

const Footer: React.FC = () => {
 const location = useLocation();
  const path = location.pathname;
  let pathstatus:number;
    if(path === '/' || path === '/solutions'){
        pathstatus=1;
    }else if(path === '/careers'){
          pathstatus=2;
     }else if(path === '/resource-detail'){
          pathstatus=3;
      }else if(path === '/privacy-policy'){
        pathstatus=5;
    }else{
        pathstatus=4;
    }
 
  return (

     <>
      <footer id="footer"  className={pathstatus === 2 ? 'footer career-footer bg-grey-gradient' : `${pathstatus === 1 ? 'mt-1' : ''} footer`}>
      
          { pathstatus === 1 && <FooterSubM /> } 
           { pathstatus === 2 && <FooterSubCareer /> }
            { pathstatus === 3 &&  <hr style={{borderColor: '#0026ff', borderWidth: '2px'}}/> }
          { pathstatus === 4 && <FooterSubONew /> }
       
        <div className="container copyright text-center footer-main">
            <div className="row gx-2">
                <div className="col-md-12 footer-main-sub d-flex justify-content-between">
                    <div className="d-md-flex footer-first">
                       
                        <p className="">
                           <span className=""><a href='/privacy-policy' >Privacy Policy</a></span>
                            <span className="ms-3"><a href='/contact-us' >Contact us</a></span>
                        </p>

                    </div>
               
                    <div className="d-lg-flex footer-second footer-web-view">
                        <span className="footer-subtitle1">  Designed and developed by <a href="https://www.hgsinteractive.com/">HGS Interactive</a> </span>
                    
                        <strong className="">|</strong>
                        <p className="footer-subtitle2"> <span className="sitename">© Gro Digital Platforms Limited - {new Date().getFullYear()}</span>
                    
                        </p>
                    </div>
                    <div className="footer-social-links  text-lg-end">
                        <div className="">
                             <a href="https://www.youtube.com/@grodigitalplatforms" rel="You Tube" target="_blank"><i className="bi bi-youtube"></i></a>
                            <a href="https://x.com/gro_digital_" rel="noopener noreferrer" target="_blank"><i className="bi bi-twitter-x"></i></a>
                            <a href="https://www.facebook.com/people/Gro-Digital-Platforms/100086709385574/" rel="noopener noreferrer" target="_blank"><i className="bi bi-facebook"></i></a>
                            <a href="https://www.instagram.com/gro_digital_platforms/" rel="noopener noreferrer" target="_blank"><i className="bi bi-instagram"></i></a>
                            <a href="https://www.linkedin.com/company/lets-gro/posts/?feedView=all" rel="noopener noreferrer" target="_blank"><i className="bi bi-linkedin"></i></a>
                        </div>
                        
 
                    </div>
                     

                </div>
                <div className="col-sm-12 d-xl-none d-lg-none footer-mobile-view d-sm-block">
                    <div className="d-lg-flex footer-second ">
                        <span className="footer-subtitle1">  Designed and developed by <a href="https://www.hgsinteractive.com/">HGS Interactive</a> </span>
                    
                        <strong className="">|</strong>
                        <p className="footer-subtitle2"> <span className="sitename">© Gro Digital Platforms Limited - {new Date().getFullYear()}</span>
                    
                        </p>
                    </div>
                </div>
                
            </div>
            {/* <div className="row gx-2">
                <div className="col-md-8 align-content-center">
                    <div className="d-md-flex ">
                        <p className="footertext">© <span>Copyright</span> 2025 <strong className="px-1 sitename">Gro Digital Platforms Limited.</strong> <span className="footerline">All Rights Reserved</span></p>
                        <p className="ms-3 footertab">
                           <span className=""><a href='/privacy-policy' style={{color:'#444444'}}>Privacy Policy</a></span>
                            <span className="ms-3"><a href='/contact' style={{color:'#444444'}}>Contact us</a></span>
                        </p>

                    </div>
                </div>
                <div className="col-md-4  text-lg-end">

                    <div className="social-links">
                        <div className="">
                            <a href="https://x.com/gro_digital_" rel="noopener noreferrer" target="_blank"><i className="bi bi-twitter-x"></i></a>
                            <a href="https://www.facebook.com/people/Gro-Digital-Platforms/100086709385574/" rel="noopener noreferrer" target="_blank"><i className="bi bi-facebook"></i></a>
                            <a href="https://www.instagram.com/gro_digital_platforms/" rel="noopener noreferrer" target="_blank"><i className="bi bi-instagram"></i></a>
                            <a href="https://www.linkedin.com/company/lets-gro/posts/?feedView=all" rel="noopener noreferrer" target="_blank"><i className="bi bi-linkedin"></i></a>
                        </div>
                        
 
                    </div>
                    <div className="credits">
                      
                        <span>  Designed and developed by <a href="#">HGS Interactive</a> </span>
                    </div>

                </div>
            </div> */}

        </div>

    </footer>
  </>
  );
};

export default Footer